import React, { useRef, useCallback } from 'react';
import styled from 'styled-components/macro';

import { Flavor } from './common/types';
import useFlavorStore from './common/store/useFlavorStore';
import Loading from './page/Loading';
import Disclaimer from './modal/Disclaimer';
import Main from './page/Main';
import useMasterTimeline from './page/useMasterTimeline';
import Navigation from './page/Navigation';
import useTriggerStore from './common/store/useTriggerStore';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  overflow: hidden;
`;

const ScrollBar = styled.div(({ $flavor }: { $flavor: Flavor }) => `
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;

  height: 100%;
  width: 6rem;

  transform: translateY(-100%);
  background: var(--${$flavor});

  transition: 0.25s background;
`);

const App = () => {

  const appleFall = useTriggerStore(useCallback(state => state.appleFall, []));

  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const scroll = useRef<HTMLDivElement>(null);

  const timeline = useMasterTimeline();


  return (
    <Wrapper>
      <ScrollBar ref={scroll} $flavor={flavor} />
      <Navigation />

      <Main scroll={scroll} />
      {!appleFall && <Loading onContinue={() => timeline.current.play(0)} />}

      <Disclaimer />
    </Wrapper>
  );
};

export default React.memo(App);
